import React, { FC } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Navigation, Autoplay } from "swiper/modules";
import { SLIEDS } from "./constants";
import { Slide } from "./Slide";

const DELAY_AUTO_SLIDE = 10000;

export const BannerSection: FC = () => {
  return (
    <section>
      <Swiper
        style={{ zIndex: 0 }}
        spaceBetween={15}
        className="relative"
        navigation={{
          nextEl: ".button-next",
          prevEl: ".button-prev",
        }}
        autoplay={{
          delay: DELAY_AUTO_SLIDE,
          disableOnInteraction: false,
        }}
        modules={[Navigation, Autoplay]}
      >
        {SLIEDS.map((slide) => (
          <SwiperSlide key={slide.id}>
            <Slide {...slide} />
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};
